import { render, staticRenderFns } from "./MunicipioIssDetalhes.vue?vue&type=template&id=14a03c31"
import script from "./MunicipioIssDetalhes.vue?vue&type=script&lang=js"
export * from "./MunicipioIssDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports